const openModalButtons = document.querySelectorAll(".js-modal-open");
const closeModalButtons = document.querySelectorAll("[data-close-button]");
const imageForModalElement = document.querySelectorAll(".image-for-modal");

function openModal(modal, scrollToID) {
	if (modal == null) return;
	modal.classList.remove("hide");
	document.body.classList.add("disable-scroll");
	// scroll inside the modal to have the focus on the middle part of the featured image
	const elementToScroll = document.getElementById(scrollToID);
	elementToScroll.addEventListener("load", () => {
		const offsetPosition = elementToScroll.offsetHeight / 4;
		// eslint-disable-next-line no-param-reassign
		modal.scrollTop = elementToScroll.offsetTop + offsetPosition;
	});
}

function closeModal(modal) {
	if (modal == null) return;
	modal.classList.add("hide");
	document.body.classList.remove("disable-scroll");
}

openModalButtons.forEach((button) => {
	button.addEventListener("click", () => {
		if (document.contains(document.getElementById("modal-images-wrapper"))) {
			document.getElementById("modal-images-wrapper").remove();
		}

		const scrollToID = button.getAttribute("data-img-id");
		const modal = document.getElementById(button.getAttribute("aria-controls"));
		const parentEl = document.createElement("div");
		parentEl.setAttribute("id", "modal-images-wrapper");
		// create image elements for modal content, apply src from clicked image's siblings attributes
		imageForModalElement.forEach((element) => {
			const img = document.createElement("img");
			img.src = element.getAttribute("data-img-src");
			img.setAttribute("id", element.getAttribute("data-img-id"));
			parentEl.appendChild(img);
			modal.appendChild(parentEl);
		});

		openModal(modal, scrollToID);
	});
});

closeModalButtons.forEach((button) => {
	button.addEventListener("click", () => {
		const modal = button.closest(".modal");
		closeModal(modal);
	});
});
